export const SET_ITEMS = 'SET_ITEMS';
export const SET_ITEM = 'SET_ITEM';
export const ADD_ITEM = 'ADD_ITEM';
export const UPDATE_ITEM = 'UPDATE_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const CLEAR_ITEM = 'CLEAR_ITEM';
export const CLEAR_ITEMS = 'CLEAR_ITEMS';
